import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ReactComponent as ErrorIcon } from '@src/assets/escher/icons/error-filled.svg';

export default function ErrorMessage({ error }) {
  return (
    <ErrorBlock>
      <ErrorWithIcon>
        <ErrorIcon width={'17px'} height={'17px'} />
        &nbsp;{error}
      </ErrorWithIcon>
    </ErrorBlock>
  );
}

ErrorMessage.propTypes = {
  error: PropTypes.string.isRequired,
};

const ErrorBlock = styled.div`
  color: ${props => props.theme.invalid};
  margin: 15px 0px 15px 10px;
  width: 100%;
`;

const ErrorWithIcon = styled.div`
  svg {
    vertical-align: middle;
    padding-bottom: 2px;
  }
`;
